import React from "react";
import CustomerProductDetails from "./CustomerProductDetails";
const SecureHome = () => {
  return (
    <div>
      
      <CustomerProductDetails />
    </div>
  );
};

export default SecureHome;
